import Vue from 'vue'
import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/endpoints'
// import digio from '../../../../digio-sdk'
const msz_display_time = 10000
import moment from 'moment';
import Api from '../../../../../store/api/axios'
import { 
	strictValidArrayWithMinLength, 
	strictValidObject, 
	validObjectWithParameterKeys 
} from "../../../../../utils/common";

export const actions = {
	[Const.RUN_GET_DIGIO_DATA]({ commit, state, dispatch, getters }, dataToSend) {
		return new Promise((resolve, reject) => {
		  try {
			commit(Const.RESET_DIGIO_DATA);
			Api.post(Enpoints.EP_RUN_GET_DIGIO_DATA, dataToSend)
			  .then((res) => {
				const { data } = res;
				resolve(data); // Resolve the Promise with the data.
			  })
			  .catch((ex) => {
				let error = 'Oops! Something went wrong';
				if (
				  validObjectWithParameterKeys(ex, ['response']) &&
				  validObjectWithParameterKeys(ex.response, ['data'])
				) {
				  const {
					data: { data: { message } = {} } = {}
				  } = ex.response;
				  error = message;
				}
				Vue.notify({
				  group: 'foo',
				  title: 'error!',
				  text: error,
				  type: 'error'
				});
	  
				_handleErrorResponse(ex, commit);
				reject(false); // Reject the Promise with `false` as the error value.
			  });
		  } catch (ex) {
			reject(ex); // Reject the Promise with the caught error.
		  }
		});
	  },
	  [Const.RUN_SEND_DIGIO_DOC_DATA]({ commit, state, dispatch, getters }, data) {
		return new Promise((resolve, reject) => {
		  try {
			if (validObjectWithParameterKeys(data, ['digio_doc_id'])) {
			  Api.post(Enpoints.EP_RUN_SEND_DIGIO_DOC_DATA, { documentId: data.digio_doc_id })
				.then((res) => {
				  const base64 = res.data.data;
				  resolve(base64); // Resolve the Promise with the base64 data.
				})
				.catch((ex) => {
				  console.log("In e blob", ex);
				  _handleErrorResponse(ex, commit);
				  reject(false); // Reject the Promise with `false` as the error value.
				});
			}
		  } catch (ex) {
			reject(ex); // Reject the Promise with the caught error.
		  }
		});
	  },
	  [Const.RUN_SEND_DIGIO_DOC_KYC_DATA]({ commit, state, dispatch, getters }, data) {
		return new Promise((resolve, reject) => {
		  try {
			if (validObjectWithParameterKeys(data, ['digio_doc_id'])) {
			  Api.post(Enpoints.EP_RUN_SEND_DIGIO_DOC_KYC_DATA, { documentId: data.digio_doc_id })
				.then((res) => {
					resolve(res)
				})
				.catch((ex) => {
				  console.log("In e blob", ex);
				  _handleErrorResponse(ex, commit);
				  reject(false); // Reject the Promise with `false` as the error value.
				});
			}
		  } catch (ex) {
			reject(ex); // Reject the Promise with the caught error.
		  }
		});
	  },
	  [Const.FETCH_IPV_REDIRECT]({commit,state,getters,dispatch}, data) {
		return new Promise((resolve, reject) => {
		  try {
			Api.post(Enpoints.EP_FETCH_IPV_REDIRECT, { id: data.id })
				.then((res) => {
					if(validObjectWithParameterKeys(res.data.data, ['token'])){
						resolve(res.data.data);
						if(res.data.data.token){
							let user = {
								token: res.data.data.token,
							}
							commit(types.SET_STATE, user)
						}
					}
					else{
						reject(false);
					}
				})
				.catch((ex) => {
					reject(false);
				});
		  } catch (ex) {
			reject(false);
		  }
		});
	  },
	  [Const.GET_VALID_SIGNATURE]({ commit, state, dispatch, getters }, data) {
		return new Promise((resolve, reject) => {
		  	try {
				let baseValue = '';
				if(data.image){
					baseValue = data.image.split(',')[1];
				}
				Api.post( process.env.AI_SIGNATURE_ADDRESS + Enpoints.EP_RUN_GET_VALID_SIGNATURE, { image: baseValue })
					.then((res) => {
						if(res.data.result && res.data.result.includes('Accepted')){
							resolve(true);
						}
						else{
							reject(false);
						}
					})
					.catch((ex) => {
						reject(false); // Reject the Promise with `false` as the error value.
					});
		  	} catch (ex) {
				reject(ex); // Reject the Promise with the caught error.
		  	}
		});
	  },
		[Const.RUN_SEND_AGGREGATOR_DATA]({commit, state,getters,dispatch}, data){    
			return new Promise((resolve, reject) => {
				try { 
					let tempURL = Enpoints.AA_BASE_URL + Enpoints.EP_SET_AGGREGATOR_REDIRECT
					Api.post(tempURL, {...data})
						.then((res) => {
							const { data } = res;
							console.log(data)
							resolve(data); // Resolve the Promise with the data.
						})
						.catch((ex) => {
							let error = 'Oops! Something went wrong';
							if (
								validObjectWithParameterKeys(ex, ['response']) &&
								validObjectWithParameterKeys(ex.response, ['data'])
							) {
							// const {
							// 	data: { data: { message } = {} } = {}
							// } = ex.response;
							console.log(ex.response)
							error = ex.response.data.message;
							}
							Vue.notify({
							group: 'foo',
							title: 'error!',
							text: error,
							type: 'error'
							});
				
							_handleErrorResponse(ex, commit);
							reject(false); // Reject the Promise with `false` as the error value.
						});
					} catch (ex) {
						console.log(ex)
						reject(ex); // Reject the Promise with the caught error.

					}
			})															
		},
	[Const.RUN_REVERSE_PENNY_DROP]({commit, state,getters,dispatch}, data){    
		return new Promise((resolve, reject) => {
			try { 
			let tempURL = Enpoints.BASE_URL + Enpoints.EP_REVERSE_PENNY_DROP
			Api.post(tempURL, {...data})
				.then((res) => {
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
					group: 'foo',
					title: 'error!',
					text: error,
					type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false); // Reject the Promise with `false` as the error value.
				});
			} catch (ex) {
				console.log(ex)
				reject(ex); // Reject the Promise with the caught error.
			}
		})															
	},
	[Const.RUN_REVERSE_PENNY_DROP_CHANGE_BANK_ACCOUNT]({commit, state,getters,dispatch}, data){    
		return new Promise((resolve, reject) => {
			try { 
			let tempURL = Enpoints.BASE_URL + Enpoints.EP_REVERSE_PENNY_DROP_CHANGE_BANK_ACCOUNT
			Api.post(tempURL, {...data})
				.then((res) => {
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
					group: 'foo',
					title: 'error!',
					text: error,
					type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false); // Reject the Promise with `false` as the error value.
				});
			} catch (ex) {
				console.log(ex)
				reject(ex); // Reject the Promise with the caught error.
			}
		})															
	},
	[Const.RUN_REVERSE_PENNY_DROP_ATTEMPT]({commit, state,getters,dispatch}, data){    
		return new Promise((resolve, reject) => {
			try { 
			let tempURL = Enpoints.BASE_URL + Enpoints.EP_REVERSE_PENNY_DROP_ATTEMPT
			Api.post(tempURL, {...data})
				.then((res) => {
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
					group: 'foo',
					title: 'error!',
					text: error,
					type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false); // Reject the Promise with `false` as the error value.
				});
			} catch (ex) {
				console.log(ex)
				reject(ex); // Reject the Promise with the caught error.
			}
		})															
	},
	[Const.RUN_REVERSE_PENNY_DROP_NAME_MATCH]({commit, state,getters,dispatch}, data){    
		return new Promise((resolve, reject) => {
			try { 
			let tempURL = Enpoints.BASE_URL + Enpoints.EP_REVERSE_PENNY_DROP_NAME_MATCH
			Api.post(tempURL, {...data})
				.then((res) => {
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
					group: 'foo',
					title: 'error!',
					text: error,
					type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false); // Reject the Promise with `false` as the error value.
				});
			} catch (ex) {
				console.log(ex)
				reject(ex); // Reject the Promise with the caught error.
			}
		})															
	},
	[Const.RUN_REVERSE_PENNY_DROP_STATUS]({commit, state,getters,dispatch}, data){    
		return new Promise((resolve, reject) => {
			try { 
			let tempURL = Enpoints.BASE_URL + Enpoints.EP_REVERSE_PENNY_DROP_STATUS + `?requestId=`+data.requestId
			Api.get(tempURL, {...data})
				.then((res) => {
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
					group: 'foo',
					title: 'error!',
					text: error,
					type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false); // Reject the Promise with `false` as the error value.
				});
			} catch (ex) {
				console.log(ex)
				reject(ex); // Reject the Promise with the caught error.
			}
		})															
	},
	[Const.GET_SDK_INVOKE_DATA]({commit, state,getters}, inputStatusHv){	
		return new Promise((resolve, reject) => {
			try {
				Api.post( Enpoints.BASE_URL + Enpoints.EP_GET_SDK_INVOKE_DATA, inputStatusHv)
				.then((res) => {
					console.log(res)
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
						group: 'foo',
						title: 'error!',
						text: error,
						type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false);
			});
			} catch (ex) {
				console.log(ex)
				reject(ex);

			}
		})	
			
	},	
	[Const.FETCH_AGGREGATOR_HEALTH]({commit, state,getters,dispatch}, data){	
		return new Promise((resolve, reject) => {
			try { 
				let tempURL = Enpoints.AA_BASE_URL + Enpoints.EP_FETCH_AGGREGATOR_HEALTH
				Api.get(tempURL, {...data})
					.then((res) => {
						const { status } = res.data;
						resolve(status);
					})
					.catch((ex) => {
						let error = 'Oops! Something went wrong';
						Vue.notify({
							group: 'foo',
							title: 'error!',
							text: error,
							type: 'error'
						});
						_handleErrorResponse(ex, commit);
						reject(false);
					});
				} catch (ex) {
					console.log(ex)
					reject(ex);

				}
		})															
	},  
	[Const.RUN_CHECK_ACCOUNT_DETAIL]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true

			let user_json = getters[types.GET_USER]
			// if(parseInt(user_json.step) == 8 && !(localStorage.getItem("step_for_gtag"))){
			// 	window.fbq('track', 'PJ_step_14');
			// 	localStorage.setItem("step_for_gtag", user_json.step);
			// }


			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHECK_ACCOUNT_DETAIL, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.grossAnnualIncome = data.data.grossAnnualIncome;
						if(data.data.status && data.data.status.toLowerCase() == 'pending'){
							parameter.userCheckFinancialDetail = data.data.status.toLowerCase()
						}else{
							parameter.userCheckFinancialDetail = ''
						}

					}else{
						parameter.userCheckFinancialDetail = ''
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_CHECK_GROSS_ANNUAL_INCOME]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true

			let user_json = getters[types.GET_USER]
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHECK_GROSS_ANNUAL_INCOME_STATUS, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {

						parameter.userCheckIsFirstYearCompleted = data.data.isFirstYearCompleted
						// parameter.userCheckDaysLeft = 1
						parameter.userCheckDaysLeft = data.data.daysLeft
						
					}else{
						// parameter.userCheckFinancialDetail = ''
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_SAVE_GROSS_ANNUAL_INCOME]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true

			let user_json = getters[types.GET_USER]
			// if(parseInt(user_json.step) == 8 && !(localStorage.getItem("step_for_gtag"))){
			// 	window.fbq('track', 'PJ_step_14');
			// 	localStorage.setItem("step_for_gtag", user_json.step);
			// }


			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_SAVE_GROSS_ANNUAL_INCOME_DETAIL, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {

						dispatch(Const.RUN_CHECK_GROSS_ANNUAL_INCOME, {
							parameter
						})
						parameter.showIncomeModal = false
						parameter.flashSuccess('Gross annual income saved successfully', {timeout: msz_display_time})
						// parameter.userCheckDaysLeft = data.data.daysLeft
						// if(data.data.status && data.data.status.toLowerCase() == 'pending'){
						// 	parameter.userCheckFinancialDetail = data.data.status.toLowerCase()
						// }else{
						// 	parameter.userCheckFinancialDetail = ''
						// }
						
					}else{
						// parameter.userCheckFinancialDetail = ''
						parameter.showIncomeModal = false
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.FETCH_FAQ_LIST]({commit, state,getters,dispatch}, data){	
		return new Promise((resolve, reject) => {
			try {
			  	Api.post(Enpoints.EP_FETCH_FAQ_LIST, {})
				.then((res) => {
					const { data } = res.data || {data: []};
					resolve(data);
				})
				.catch((ex) => {
				  	let error = 'Oops! Something went wrong';
					Vue.notify({
						group: 'foo',
						title: 'error!',
						text: error,
						type: 'error'
					});
				  	_handleErrorResponse(ex, commit);
				  	reject(false);
				});
			} 
			catch (ex) {
			  	reject(ex);
			}
		});
	},
	  

[Const.RUN_CHECK_DASHBOARD_STATS]({commit, state,getters,dispatch}, data){	
		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHECK_DASHBOARD_STATS, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						console.log(data)
						commit(Const.SET_DASHBOARDSTATS, data.data)

					}else{
						console.log(data)
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
	},
	[Const.RUN_USER_PAN_ATTEMPT_NAME_API]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_PAN_ATTEMPT_NAME_API, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						//parameter.flashSuccess('pan name fetched successfully', {timeout: msz_display_time})
						parameter.panAttempt = data.data
						webengage.track("Verify Pan Card Success", {"Value": "Yes"});
						console.log("Verify Pan Card Success")
						
					}else{
						webengage.track("Verify Pan Card Failed", {"Value": "Yes"});
						console.log("Verify Pan Card Failed")

						if(Object.keys(parameter.panAttempt).length > 0){
							parameter.errMsz = data.msg
							parameter.flashError(parameter.errMsz, {timeout: msz_display_time})
						}else{ 
							parameter.flashError(data.msg, {timeout: msz_display_time})
						}
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	  [Const.RUN_USER_PAN_ATTEMPT_DIGITAP_API]({commit, state,getters,dispatch}, data){	
		try {
		  const inputJson = data
		  const parameter = inputJson.parameter
		  delete inputJson.parameter
		  parameter.pageLoader = true
		  RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_PAN_ATTEMPT_DIGITAP_API, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
		  .map(response => response.data)
		  .subscribe(data => 
		  {	parameter.pageLoader = false

				// if ('info' in data){
				// 	console.log(data)
				// }
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.panAttempt = data.data
						webengage.track("Verify Pan Card Success", {"Value": "Yes"});
						console.log("Verify Pan Card Success")
						
					}else{
						webengage.track("Verify Pan Card Failed", {"Value": "Yes"});
						console.log("Verify Pan Card Failed")
						if(Object.keys(parameter.panAttempt).length > 0){
							
							parameter.errMsz = data.msg
							parameter.flashError(parameter.errMsz, {timeout: msz_display_time})
						}else{ 
							parameter.flashError(data.msg, {timeout: msz_display_time})
						}
					}
				}
		  },
		  e => {	_handleErrorResponse(e, commit)	}) 
	  }catch(ex){	_handleErrorResponse(ex, commit) }
	},

  	[Const.RUN_ADD_GEOLOCATION]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADD_GEOLOCATION, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				if ('info' in data){
					if (data.info === 'OK') {}
					else{}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_BAKSTAGED_TICKET]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			// parameter.root_file_address.pageLoader = true
			parameter.$parent.$parent.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_BAKSTAGED_TICKET, inputJson.form ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.$parent.$parent.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.$parent.viewListDetail({'id' : inputJson.ticketId})
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_GET_BANK_INFORMATION_IN_DETAIL]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_BANK_INFORMATION_IN_DETAIL, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							commit(Const.SET_BANK_INFORMATION_IN_DETAIL,data.data)
							parameter.focusOutIfsc1()
						}else{
							commit(Const.SET_BANK_INFORMATION_IN_DETAIL,[])
							parameter.focusOutIfsc1()
						}
					}
					else{	
						commit(Const.SET_BANK_INFORMATION_IN_DETAIL,[])
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	//===================api key=================================

	[Const.RUN_MARGIN_PLEDGE_SUCCESS_ISIN]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.$parent.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_MARGIN_PLEDGE_SUCCESS_ISIN, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				
				if ('info' in data){
					if (data.info === 'OK') {
						// let arrayDummy = [
						// 	{
					 //            "user_id": 21,
					 //            "resstatus": "0",
					 //            "created": "2022-11-29T15:54:21.000Z",
					 //            "isin": "INE111B01023",
					 //            "quantity": "1"
					 //        },
					 //        {
					 //            "user_id": 21,
					 //            "resstatus": "0",
					 //            "created": "2022-11-29T15:57:42.000Z",
					 //            "isin": "IN0020140052",
					 //            "quantity": "1"
					 //        },
					 //        {
					 //            "user_id": 21,
					 //            "resstatus": "0",
					 //            "created": "2022-11-29T15:54:21.000Z",
					 //            "isin": "INF209K01ZC0",
					 //            "quantity": "1"
					 //        },
					 //        {
					 //            "user_id": 21,
					 //            "resstatus": "0",
					 //            "created": "2022-11-29T15:57:42.000Z",
					 //            "isin": "IN0020140052",
					 //            "quantity": "10"
					 //        }
				  //       ]
				  //       data.data = arrayDummy
				        let i, secondArray = [] ;
				        if(data.data.length > 0){
				        	for(i=0 ; i<=data.data.length-1 ; i++){
								if(i==data.data.length-1){
									if(data.data[i].is_done && parseInt(data.data[i].is_done) == 1){
										commit(Const.SET_MARGIN_PLEDGE_SUCCESS_ISIN,secondArray)
									}else{
										secondArray.push(data.data[i])
										commit(Const.SET_MARGIN_PLEDGE_SUCCESS_ISIN,secondArray)
									}
								}else{
									for(let j = i+1 ; j<= data.data.length-1 ; j++){
										if(data.data[i].isin == data.data[j].isin){
											data.data[i].quantity = parseFloat(data.data[i].quantity) + parseFloat(data.data[j].quantity)
											data.data[j]['is_done'] = 1
											data.data[i]['is_done'] = 1
										}

										if(j == data.data.length-1){
											secondArray.push(data.data[i])
										}
									}
								}
							}
				        }else{
				        	commit(Const.SET_MARGIN_PLEDGE_SUCCESS_ISIN,[])
				        }
					}
					else{
						commit(Const.SET_MARGIN_PLEDGE_SUCCESS_ISIN,[])
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_MARGIN_PLEDGE_REQUEST_DETAIL]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_MARGIN_PLEDGE_REQUEST_DETAIL, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.successData = data.data
						// {
						// 	"reqid": "301120221900261039724",
					 //        "resElement": {
					 //            "pledgeresdtls": {
					 //                "reqid": "301120221900261039724",
					 //                "pledgeidentifier": "MP",
					 //                "resid": "5587181",
					 //                "restime": "30112022190043",
					 //                "resstatus": "0",
					 //                "reserror": "",
					 //                "reserrmsg": "",
					 //                "remarks": "API CALL",
					 //                "isinresdtls": [
					 //                    {
					 //                        "isinreqid": "301120221046246",
					 //                        "isinresid": "14007352",
					 //                        "isin": "INE382M01027",
					 //                        "quantity": "5",
					 //                        "status": "0",
					 //                        "errorcode": "",
					 //                        "errormsg": ""
					 //                    }
					 //                ]
					 //            }
					 //        }
					 //    }
					}
					else{
						parameter.successData = {}
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},


  	[Const.RUN_MARGIN_PLEDGE_REQUEST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.$parent.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_MARGIN_PLEDGE_REQUEST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.marginPledgeRequestData = data.data
						setTimeout(function(){ parameter.$parent.pageLoader1 = false ;  parameter.submitNow()  }, 6000);
					}
					else{
						parameter.marginPledgeRequestData = {}
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_PLEDGE_APPROVED_ISINS]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_PLEDGE_APPROVED_ISINS, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						commit(Const.SET_PLEDGE_APPROVED_ISINS,data.data)
					}
					else{
						commit(Const.SET_PLEDGE_APPROVED_ISINS,[])	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_KSOFT_PROFILE_API]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_KSOFT_PROFILE_API, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						let segmentArray = {}, nse_seg = 0, mcx_seg = 0 ;
						let segmentsJson = {
							// 'CAP': {'key': 'CM','value': 'CASH', 'priority' : '0'},
							// 'FNO': {'key': 'FO','value': 'FNO', 'priority' : '1'},
							// 'CUR': {'key': 'CD','value': 'CDS', 'priority' : '2'},
							
							'ALL': {'key': 'AL' , 'value': 'NSE/BSE ( All Segments)', 'priority' : '1' } ,
							'COM': {'key': 'CO','value': 'MCX', 'priority' : '2'}
						};

						// var order  = [3,1,4,0,2];


						//cash , fo, cds mcx // order
						if(data.data.SegmentMaster.length > 0){
							for(let i=0 ; i<= data.data.SegmentMaster.length-1 ; i++){
								if((data.data.SegmentMaster[i].ExchangeID == 'NSE' || data.data.SegmentMaster[i].ExchangeID == 'BSE') && parseInt(nse_seg) == 0){
									nse_seg = 1
									segmentArray[0] = {'SegmentValue' : 'AL' , 'SegmentName' : 'NSE/BSE ( All Segments)' }
								}

								if(data.data.SegmentMaster[i].ExchangeID == 'MCX' && parseInt(mcx_seg) == 0){
									mcx_seg = 1
									segmentArray[1] = {'SegmentValue' : 'CO' , 'SegmentName' : 'MCX' }
								}

								
								if(i == data.data.SegmentMaster.length-1){
									data.data['segments'] = segmentArray
									commit(Const.SET_KSOFT_PROFILE_API,data.data)
								}
							}
						}else{
							commit(Const.SET_KSOFT_PROFILE_API,data.data)
						}
					}
					else{
						commit(Const.SET_KSOFT_PROFILE_API,[])	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_GET_GENERATE_API_KEY]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_GENERATE_API_KEY, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.apiKeyDetail()
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_GET_API_KEY_DETAIL]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_API_KEY_DETAIL, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							parameter.ApiKey = data.data[0].ApiKey
						}else{
							parameter.ApiKey = ''
						}
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	//=======================nominee data=========================
  	[Const.RUN_GET_CLIENT_NOMINEE_DATA]({commit, state,getters,dispatch}, data){
  		try {
  			console.log('data',data)
			const inputJson = data
			const parameter = inputJson.parameter
			const from = inputJson.from
			delete inputJson.parameter
			delete inputJson.rout
			delete inputJson.from
			parameter.pageLoader = true
			
			function convertToIstDate(date){
				const parsedDate = moment(date, 'DD-MM-YYYY');
				const formattedDate = parsedDate.format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (India Standard Time)');
				return formattedDate
			}

			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CLIENT_NOMINEE_DATA, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							parameter.data_exsist = 1
							if(from == "step1_5"){
								parameter.nomineeArray = []
								if(data.data.length > 0 ) {
									parameter.nominate = 'yes'
									for(let [key,value] of Object.entries(data.data)){
										let statevalue = "", NGSTATE = "" ;
										for(const statekey of Object.keys(state.state_list_code)){
											if(state.state_list_code[statekey] == value.NSTATE){
												statevalue = statekey
											}
											if(state.state_list_code[statekey] == value.NGSTATE){
												NGSTATE = statekey
											}
										}
										let countryvalue = "", NGCOUNTRY = "" ;
										for(const countrykey of Object.keys(state.country_list)){
											if(state.country_list[countrykey] == value.NCOUNTRY){
												countryvalue = countrykey
											}
											if(state.country_list[countrykey] == value.NGCOUNTRY){
												NGCOUNTRY = countrykey
											}
										}

										parameter.nomineeArray.push(parseInt(key))

										parameter.nomineeAddJson[key].nominee_id = value.id
										parameter.nomineeAddJson[key].email = value.NEMAILNO
										parameter.nomineeAddJson[key].name = value.NNAME
										parameter.nomineeAddJson[key].share = value.PERCENTAGE
										parameter.nomineeAddJson[key].realtionship = value.RELATION
										parameter.nomineeAddJson[key].realtionship_other = value.NEMAILNO
										parameter.nomineeAddJson[key].city = {city: value.NADD2, id: value.city_mapping_id}
										parameter.nomineeAddJson[key].other_city = value.other_city || '';

										parameter.nomineeAddJson[key].state = statevalue
										parameter.nomineeAddJson[key].country = countryvalue
										parameter.nomineeAddJson[key].pincode = value.NPINCODE
										parameter.nomineeAddJson[key].identity_detail = value.NOTHERID
										parameter.nomineeAddJson[key].identity_detail_number = (value.NPANNO != '' && value.NPANNO != null) ? value.NPANNO  : (value.NAADHARNO != '' && value.NAADHARNO != null) ? value.NAADHARNO : value.NOTHERNUMBER
										
										parameter.nomineeAddJson[key].mobile = value.NMOBILENO
										parameter.nomineeAddJson[key].address = value.NADD1
										parameter.nomineeAddJson[key].dob = convertToIstDate(value.NDOB)

										parameter.nomineeAddJson[key].guardian_dob = convertToIstDate(value.guardian_dob)
										parameter.nomineeAddJson[key].guardian_name = value.NGNAME
										parameter.nomineeAddJson[key].guardian_address = value.NGADD1
										parameter.nomineeAddJson[key].guardian_phone = value.guardian_phone
										parameter.nomineeAddJson[key].guardian_email = value.guardian_email
										parameter.nomineeAddJson[key].guardian_relationship = value.NGRELATION
										parameter.nomineeAddJson[key].guardian_pincode = value.NGPINCODE
										parameter.nomineeAddJson[key].guardian_city = {city: value.NGADD2, id: value.guardian_city_mapping_id}
										parameter.nomineeAddJson[key].guardian_other_city = value.guardian_other_city || '';
										parameter.nomineeAddJson[key].guardian_state = NGSTATE
										parameter.nomineeAddJson[key].guardian_country = NGCOUNTRY
										parameter.nomineeAddJson[key].guardian_identity_detailss = value.guardian_identity_detailss
										parameter.nomineeAddJson[key].guardian_identity_detail_number = value.guardian_identity_detail_number

										if(value.nominee === 1)
											parameter.nominate = 'yes'
										else
											parameter.nominate = 'no'
									}
								}else{
									parameter.nominate = 'no'
								}
								
							}
							commit(Const.SET_CLIENT_NOMINEE_DATA,data.data)
						}else{
							parameter.data_exsist = 0
							commit(Const.SET_CLIENT_NOMINEE_DATA,[])
						}
					}
					else{	
						parameter.data_exsist = 0
						commit(Const.SET_CLIENT_NOMINEE_DATA,[])
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {
				_handleErrorResponse(e, commit)	
			}) 
		}catch(ex){	
			_handleErrorResponse(ex, commit) 
		}
  	},

	//======================referral coupon========================

	[Const.RUN_GET_COUPONS_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.$parent.pageLoader = false
			parameter.$parent.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CATALOG_PRODUCT_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.$parent.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							commit(Const.SET_COUPONS_LIST,data.data)
						}else{
							commit(Const.SET_COUPONS_LIST,[])
						}
					}
					else{	
						commit(Const.SET_COUPONS_LIST,[])
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_GET_BALANCE_AMOUNT]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			if(inputJson.page && inputJson.page != undefined){
				parameter.$parent.pageLoader = false
				delete inputJson.page
			}
			//parameter.pageLoader = true
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CHECK_BALANCE, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				
				parameter.$parent.pageLoader = false

				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							commit(Const.SET_BALANCE_AMOUNT,data.data)
							if (localStorage.getItem("productdata")){
								parameter.productdata = JSON.parse(localStorage.getItem("productdata"));
								let sum =0;
								parameter.productdata.filter(val=>{
									sum +=  parseInt(val.price);
								})
								//parameter.reducedBalance = parseInt(data.data[0].totalAmount)-parseInt(sum)
								let getbalance = parseInt(data.data[0].totalAmount)-parseInt(sum)
								commit(Const.SET_PENDING_BALANCE,[getbalance])
							}
							
						}else{
							commit(Const.SET_BALANCE_AMOUNT,[])
						}
					}
					else{	
						commit(Const.SET_BALANCE_AMOUNT,[])
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_CREATE_COUPON_ORDER]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			parameter.$parent.pageLoader = true
			let responseWait = false
			setTimeout(function(){ 
				 if(!responseWait){
				 	parameter.$parent.pageLoader = false
				 	// parameter.congo = true
				 	parameter.$parent.getAvailableBalance()
				 	parameter.$parent.getOrderHistorylist('status')
				 	parameter.$router.push('/referal-coupon/order-history')
				 	//parameter.$parent.$refs.orderhistorypage.refreshOrderStatus(parameter.referenceno,'',item.productName,'loader')
				 	parameter.productname.forEach((item,index)=>{
					 	parameter.$parent.refreshOrderStatus(parameter.referenceno,'',item,'loader')
					});
				 	//localStorage.setItem("placeorder",'true');

				 }
			}, 60000);
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CREATE_ORDER, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				responseWait = true
				parameter.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						// parameter.congo = true
						parameter.$router.push('/referal-coupon/order-history')
						localStorage.setItem("placeorder",'true');
						parameter.$parent.resetcart()
						parameter.$parent.getAvailableBalance()
						parameter.$parent.getOrderHistorylist('status')

					}
					else{
						// parameter.congo = true
						// parameter.createOrderError = true
						// parameter.OrderErrormsg = data.msg

						// parameter.$router.push('/referal-coupon/order-history')
						// localStorage.setItem("placeorder",'true');
						// parameter.$parent.resetcart()
						// parameter.$parent.getAvailableBalance()
						// parameter.$parent.getOrderHistorylist('status')
						parameter.flashError(data.msg, {timeout: msz_display_time})
						setTimeout(function(){ 
							parameter.productname.forEach((item,index)=>{
						 		parameter.$parent.refreshOrderStatus(parameter.referenceno,'',item,'loader')
							});
						},60000);
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_GET_COUPON_ORDER_HISTORY_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			// if(inputJson.pagename && inputJson.pagename != undefined){
			// 	parameter.pageLoader = false
			// 	delete inputJson.pagename
			// }

			if(inputJson.loadfunc && inputJson.loadfunc == 'true'){
				parameter.$parent.pageLoader = false
			}else{
				parameter.$parent.pageLoader = true
			}

			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_ORDER_HISTORY_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.$parent.pageLoader = false

				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.totalRecords > 0){
							commit(Const.SET_COUPON_ORDER_HISTORY_LIST,data.data)
							//let lastFiveOrder = [],storagearray = [];
							//console.log('========',typeof localStorage.getItem('placeorder'))
							// if(localStorage.getItem('placeorder') && localStorage.getItem('placeorder') == 'true'){
							// 	//if(data.data.records.length > 5){
							// 		for(let i=0 ; i<=data.data.records.length-1 ; i++){
							// 			//console.log(i)
							// 			if(i < 2){
							// 				if((data.data.records[i].status).toUpperCase() == 'PROCESSING'){
							// 					let json ={
							// 	                    "refno": data.data.records[i].refno,
							// 	                    "status": data.data.records[i].status,
							// 	                    "productName": data.data.records[i].productName,
							// 					}
							// 					storagearray.push(json)
							// 				}
							// 			}
							// 			//console.log("after==========",i , data.data.records.length-1)
							// 			if(i == data.data.records.length-1 && storagearray.length > 0){
							// 				localStorage.setItem("checkstatus",JSON.stringify(storagearray));
							// 				if(localStorage.getItem('checkstatus')){
							// 					setTimeout(function(){
							// 						var data = JSON.parse(localStorage.getItem('checkstatus'))
							// 						data.forEach((item,index)=>{
							// 							parameter.$refs.orderhistorypage.refreshOrderStatus(item.refno,item.status,item.productName,'loader')
							// 						})
							// 						localStorage.setItem("placeorder",'false');
							// 					}, 40000);
							// 				}
							// 			}
							// 		}
									
							// 	//}
							// }
						}else{
							commit(Const.SET_COUPON_ORDER_HISTORY_LIST,{'records' :{},'totalRecords' : 0})
						}
					}
					else{	
						commit(Const.SET_COUPON_ORDER_HISTORY_LIST,{'records' :{},'totalRecords' : 0})
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_CHECK_COUPON_ORDER_STATUS]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			if(inputJson.loader && inputJson.loader == 'true'){
				parameter.$parent.pageLoader = true
			}else{
				parameter.$parent.pageLoader  = false
			}
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHECK_ORDER_STATUS, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.$parent.pageLoader  = false
				if ('info' in data){
					if (data.info === 'OK') {
						// if(localStorage.getItem('checkstatus')){
						// 	localStorage.removeItem('checkstatus')
						// }
						
						if(data.data && data.data == 'true'){
							parameter.getAvailableBalance()
							parameter.getOrderHistorylist('status')
						}
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_COUPON_ORDER_RESEND]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			parameter.$parent.pageLoader  = true
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ORDER_RESEND, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.$parent.pageLoader  = false
				if ('info' in data){
					if (data.info === 'OK') {
						let response_msz = 'Coupon has been sent successfully at your registerd email adress and mobile number'
						parameter.flashSuccess(response_msz, {timeout: msz_display_time})
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},


	//===============================================================
	[Const.RUN_GET_CATALOG_PRODUCT_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.pageLoader1 = true
		
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CATALOG_PRODUCT_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							parameter.coupondata = data.data
							commit(Const.SET_CATALOG_PRODUCT_LIST,data.data)
						}else{
							commit(Const.SET_CATALOG_PRODUCT_LIST,{})
						}
					}
					else{	
						commit(Const.SET_CATALOG_PRODUCT_LIST,{})
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_GET_CHECK_BALANCE]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			if(inputJson.page && inputJson.page != undefined){
				parameter.pageLoader = false
				delete inputJson.page
			}
			//parameter.pageLoader = true
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CHECK_BALANCE, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				
				parameter.pageLoader = false

				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							commit(Const.SET_CHECK_BALANCE,data.data)
							if (localStorage.getItem("productdata")){
								parameter.productdata = JSON.parse(localStorage.getItem("productdata"));
								let sum =0;
								parameter.productdata.filter(val=>{
									sum+=  parseInt(val.price);
								})
								parameter.reducedBalance = parseInt(data.data[0].totalAmount)-parseInt(sum)
							}
							
						}else{
							commit(Const.SET_CHECK_BALANCE,[])
						}
					}
					else{	
						commit(Const.SET_CHECK_BALANCE,[])
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_CREATE_ORDER]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			parameter.pageLoader = true
			let responseWait = false
			setTimeout(function(){ 
				 if(!responseWait){
				 	parameter.pageLoader = false
				 	// parameter.congo = true
				 	parameter.getBalance()
				 	parameter.getOrderHistory('status')
				 	parameter.$router.push('/coupon-list/order-history')
				 	localStorage.setItem("placeorder",'true');

				 }
			}, 10000);
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CREATE_ORDER, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				responseWait = true
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						// parameter.congo = true
						parameter.$router.push('/coupon-list/order-history')
						localStorage.setItem("placeorder",'true');
						parameter.reset()
						parameter.getBalance()
						parameter.getOrderHistory('status')

					}
					else{
						// parameter.congo = true
						// parameter.createOrderError = true
						// parameter.OrderErrormsg = data.msg
						parameter.$router.push('/coupon-list/order-history')
						localStorage.setItem("placeorder",'true');
						parameter.reset()
						parameter.getBalance()
						parameter.getOrderHistory('status')
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_GET_ORDER_HISTORY_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			// if(inputJson.pagename && inputJson.pagename != undefined){
			// 	parameter.pageLoader = false
			// 	delete inputJson.pagename
			// }

			if(inputJson.loadfunc && inputJson.loadfunc == 'true'){
				parameter.pageLoader = false
			}else{
				parameter.pageLoader = true
			}

			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_ORDER_HISTORY_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false

				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.totalRecords > 0){
							commit(Const.SET_ORDER_HISTORY_LIST,data.data)
							let lastFiveOrder = [],storagearray = [];
							//console.log('========',typeof localStorage.getItem('placeorder'))
							if(localStorage.getItem('placeorder') && localStorage.getItem('placeorder') == 'true'){
								//if(data.data.records.length > 5){
									for(let i=0 ; i<=data.data.records.length-1 ; i++){
										//console.log(i)
										if(i < 2){
											if((data.data.records[i].status).toUpperCase() == 'PROCESSING'){
												let json ={
								                    "refno": data.data.records[i].refno,
								                    "status": data.data.records[i].status,
								                    "productName": data.data.records[i].productName,
												}
												storagearray.push(json)
											}
										}
										//console.log("after==========",i , data.data.records.length-1)
										if(i == data.data.records.length-1 && storagearray.length > 0){
											localStorage.setItem("checkstatus",JSON.stringify(storagearray));
											if(localStorage.getItem('checkstatus')){
												setTimeout(function(){
													var data = JSON.parse(localStorage.getItem('checkstatus'))
													data.forEach((item,index)=>{
														parameter.refresh(item.refno,item.status,item.productName,'loader')
													})
													localStorage.setItem("placeorder",'false');
												}, 40000);
											}
										}
									}
									
									
								//}
							}
						}else{
							commit(Const.SET_ORDER_HISTORY_LIST,{'records' :{},'totalRecords' : 0})
						}
					}
					else{	
						commit(Const.SET_ORDER_HISTORY_LIST,{'records' :{},'totalRecords' : 0})
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_CHECK_ORDER_STATUS]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			if(inputJson.loader && inputJson.loader == 'true'){
				parameter.pageLoader = true
			}else{
				parameter.pageLoader = false
			}
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHECK_ORDER_STATUS, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(localStorage.getItem('checkstatus')){
							localStorage.removeItem('checkstatus')
						}
						if(data.data && data.data == 'true'){
							parameter.getOrderHistory('status')
							parameter.getBalance()
						}
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_ORDER_RESEND]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			parameter.pageLoader = true
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ORDER_RESEND, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						let response_msz = 'Coupon has been sent successfully at your registerd email adress and mobile number'
						parameter.flashSuccess(response_msz, {timeout: msz_display_time})
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_REFUND_BALANCE]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			parameter.pageLoader = true
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_REFUND_BALANCE, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.getBalance()
						parameter.getOrderHistory('status')
						let response_msz = 'Your points has been credited to your account.'
						parameter.flashSuccess(response_msz, {timeout: msz_display_time})
					}
					else{	
						parameter.flashError(data.data, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	//=====================coupon-module=============================

	[Const.RUN_GET_MF_CHART_DATA]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			parameter.mfChartLoading = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_MF_CHART_DATA, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				
				if ('info' in data){
					if (data.info === 'OK') {
						//console.log(data.data.plotGraphArray)
						if(Object.keys(data.data).length > 0 && Object.keys(data.data.plotGraphArray).length > 0){
							let count = 0 , catJson = {}, seriesJson = {};
							for(let key in data.data.plotGraphArray){
								count++
								if(data.data.userPortfolioFundList.hasOwnProperty(key)){
									catJson[data.data.userPortfolioFundList[key]] = []
									seriesJson[data.data.userPortfolioFundList[key]] = [{'name' : data.data.userPortfolioFundList[key] , 'data' : []}]


									seriesJson[Object.keys(data.data.plotGraphArray)[0]].push({'name' : data.data.userPortfolioFundList[key] , 'data' : []})
								}else{
									catJson[key] = []
									seriesJson[key] = [{'name' : key , 'data' : []}]
								}
								
								let innerCount = 0
								for(let innerKey in data.data.plotGraphArray[key]){
									innerCount++
									var d1 = new Date(innerKey);
									d1 = d1.getFullYear() + "-" + (d1.getMonth()+1) + "-" + d1.getDate()
									var minimumAllowDate = new Date(data.data.minStartDate);
									minimumAllowDate = minimumAllowDate.getFullYear() + "-" + (minimumAllowDate.getMonth()+1) + "-" + minimumAllowDate.getDate()
									//console.log(d1,minimumAllowDate)

									if(catJson.hasOwnProperty(data.data.userPortfolioFundList[key])){
										//var minimumAllowDate1 = new Date(data.data.myPortfolioInfo[key].date[0])
										//minimumAllowDate1 = minimumAllowDate1.getFullYear() + "-" + (minimumAllowDate1.getMonth()+1) + "-" + minimumAllowDate1.getDate()
										//if(d1 >=  minimumAllowDate1){alert()
											catJson[data.data.userPortfolioFundList[key]].push(innerKey)
											seriesJson[data.data.userPortfolioFundList[key]][0].data.push(data.data.plotGraphArray[key][innerKey].navrs)
										//}


										for(let i=0 ; i<=seriesJson[Object.keys(data.data.plotGraphArray)[0]].length-1 ; i++){
											if(seriesJson[Object.keys(data.data.plotGraphArray)[0]][i].name == data.data.userPortfolioFundList[key] && (d1 >= minimumAllowDate)){
												seriesJson[Object.keys(data.data.plotGraphArray)[0]][i].data.push(data.data.plotGraphArray[key][innerKey].navrs)
											}
										}
									}else{
										if(d1 >= minimumAllowDate){
											catJson[key].push(innerKey)
											seriesJson[key][0].data.push(data.data.plotGraphArray[key][innerKey].navrs)
										}
									}
								}

								if(count == Object.keys(data.data.plotGraphArray).length){
									parameter.mfChartLoading = false
									commit(Const.SET_MF_CHART_DATA, {'catJson' : catJson, 'seriesJson' : seriesJson, 'userPortfolioFundList' : data.data.userPortfolioFundList})
									parameter.mutualFundChart(Object.keys(catJson)[0])
								}
							}
						}else{
							parameter.mfChartLoading = false
							commit(Const.SET_MF_CHART_DATA, {})
						}
					}
					else{	
						parameter.mfChartLoading = false
						commit(Const.SET_MF_CHART_DATA, {})
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_GET_COUPON_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter

			if(inputJson.page && inputJson.page != undefined){
				parameter.pageLoader = false
				delete inputJson.page
			}else{
				parameter.pageLoader = true
			}
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_COUPON_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				if(parameter.pageLoader = true){
					parameter.pageLoader = false
				}
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length > 0){
							var earned_rewards = ((data.data[0].reedemed_amount == null) ? 0 : data.data[0].reedemed_amount);
							var claim_rewards = ((data.data[0].total_amount == null) ? 0 : data.data[0].total_amount);
							var commit_data ={'list_data':data.data,'earned_reward':earned_rewards, 'claim_reward':claim_rewards}

							commit(Const.SET_SCRATCH_COUPON,commit_data)
						}else{
							commit(Const.SET_SCRATCH_COUPON,{'list_data':[],'earned_reward':0, 'claim_reward':0})
						}
					}
					else{	
						commit(Const.SET_SCRATCH_COUPON,{'list_data':[],'earned_reward':0, 'claim_reward':0})
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_COUPON_REFERALL_MUTUAL_FUND]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter


			
				parameter.pageLoader = true
			
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_COUPON_REFERALL_MUTUAL_FUND, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.mutual_fund_list = data.data
					}
					else{	
						parameter.mutual_fund_list = []
						
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_COUPON_SCRATCH]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			//parameter.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_COUPON_SCRATCH, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	//parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.getCounponList()
						dispatch(Const.RUN_GET_COUPON_LIST, {"page": 'from_scratch',"parameter" : parameter})
					}else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_COUPON_REEDEM]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			parameter.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_COUPON_REEDEM, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.getCounponList()
						let response_msz = 'Shortly, you will get a mutual fund of Rs'+inputJson.amount+' and same will be updated on your account.'
						parameter.flashSuccess(response_msz, {timeout: msz_display_time})
					}else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},


	//===============================================================
	[Const.RUN_CHANGE_PASSWORD]({commit, state,getters,dispatch}, data){	
  		try {
			
			const inputJson = data
			const parameter = inputJson.localParams.parameter
			delete inputJson.localParams.parameter
			parameter.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHANGE_PASSWORD, inputJson.globalParams ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.reset()
						parameter.flashSuccess('Password changed successfully', {timeout: msz_display_time})
						
					}else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_CREATE_MANDATE]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			parameter.pageLoader1 = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CREATE_MANDATE, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.$router.replace('/mandate-list')
						parameter.flashSuccess('create mandate data successfully', {timeout: msz_display_time})
					}
					else{	
						// parameter.mandate_list = {}
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_PORTFOLIO_PAY]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			parameter.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_PORTFOLIO_PAY, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.pageLoader = false
						//console.log(data.data)
						window.open(data.data,'_blank');
					}
					else{	
						parameter.pageLoader = false
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_GET_MANDATE_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			parameter.pageLoader1 = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_MANDATE_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.mandate_list = data.data
					}
					else{	
						parameter.mandate_list = {}
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_GET_PORTFOLIO_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			parameter.pageLoader1 = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_PORTFOLIO_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						commit(Const.SET_PORTFOLIO_LIST_DATA,data.data)
						//parameter.portfolio_list = data.data
						let totalPledgeAmount = 0 , totalUnPledgeAmount = 0 ;
						if(data.data.length > 0 && inputJson.request_type == 'myportfolio'){
							for(let i=0 ; i<= data.data.length-1 ; i++){
								//let getAmount = parseFloat(data.data[i].MfPortfolio.units) * parseFloat(data.data[i].MfPortfolio.nav_rs)
								//total += getAmount
								if(data.data[i].MfPortfolio.others.toLowerCase() == 'y'){
									let getPledgedAmount = parseFloat(data.data[i].MfPortfolio.units) * parseFloat(data.data[i].MfPortfolio.nav_rs)
									totalPledgeAmount += getPledgedAmount
								}

								if(data.data[i].MfPortfolio.others.toLowerCase() == 'n'){
									let getUnPledgedAmount = parseFloat(data.data[i].MfPortfolio.units) * parseFloat(data.data[i].MfPortfolio.nav_rs)
									totalUnPledgeAmount += getUnPledgedAmount
								}
								
								if(i ==  data.data.length-1){
									let total = totalPledgeAmount + totalUnPledgeAmount
									commit(Const.SET_PORTFOLIO_LIST_DATA_AMOUNT,{'totalAmount' : total, 'totalPledgedAmount' : totalPledgeAmount , 'totalUnPledgedAmount' : totalUnPledgeAmount})
								}
							}
						}else{
							commit(Const.SET_PORTFOLIO_LIST_DATA_AMOUNT,{'totalAmount' : 0, 'totalPledgedAmount' : 0 , 'totalUnPledgedAmount' : 0})
						}
					}
					else{	
						commit(Const.SET_PORTFOLIO_LIST_DATA,[])
						commit(Const.SET_PORTFOLIO_LIST_DATA_AMOUNT,{'totalAmount' : 0, 'totalPledgedAmount' : 0 , 'totalUnPledgedAmount' : 0})
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},


  	[Const.RUN_GET_IB_LIST]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			
			parameter.pageLoader1 = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_IB_LIST, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader1 = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(inputJson.hasOwnProperty('limit')){
							if(data.data.records.length > 0){
								for(let i=0 ; i <= data.data.records.length-1 ; i++){
									if(data.data.records[i].account_verified_dt && data.data.records[i].account_verified_dt != '' && data.data.records[i].account_verified_dt != null){
										var currentDate = moment().format('DD-MM-YYYY');
										var verifiedDate = moment(data.data.records[i].account_verified_dt);
										var futureDate =  moment(moment(verifiedDate).add(1, 'M')).format('DD-MM-YYYY');
										// console.log(moment(futureDate).isBefore(currentDate), 'futuredate======>',futureDate,"currentdate====>", currentDate)

										if(data.data.records[i].amount && (data.data.records[i].amount == null || parseInt(data.data.records[i].amount) == 0 )  && moment(futureDate).isBefore(currentDate)){
											data.data.records[i].amount = 'Expired'
										}else if(data.data.records[i].amount == null){
											data.data.records[i].amount = 0 
										}
									}else if(data.data.records[i].account_verified_dt == null){
										data.data.records[i].amount = 'Expired'
									}
									if(i == data.data.records.length-1){
										parameter.ib_list = data.data
									}
								}
							}else{
								parameter.ib_list = {'total_records' : 0 , 'records' : []}
							}
						}else{
							parameter.ib_list = data.data[0]
						}
					}
					else{	
						parameter.ib_list = {'total_records' : 0 , 'records' : []}
						//parameter.ib_list1 = []
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_USER_FUNCTION]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			
			parameter.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_FUNCTION, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						//commit(Const.SET_PROFILE_LIST, data.data)
						//dispatch(Const.RUN_GET_CATEGORIZATION2, {"rout": rout,"parameter" : parameter,"profile_data" : data.data});
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
//----------------------------categorization api------------------------
	[Const.RUN_GET_CATEGORIZATION_API]({commit, state,getters,dispatch}, data){																
  		try {
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			
			parameter.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CATEGORIZATION, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(data.data.length >0){
							rout.push('/required/document/verification')
						}else{
							rout.push('/Segments/segment')
						}
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_GET_CATEGORIZATION]({commit, state,getters,dispatch}, data){	
  		try {
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			delete inputJson.page
			
			parameter.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_PROFILE_LISTING, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				if ('info' in data){
						if (data.info === 'OK') {
							commit(Const.SET_PROFILE_LIST, data.data)
							dispatch(Const.RUN_GET_CATEGORIZATION2, {"rout": rout,"parameter" : parameter,"profile_data" : data.data});
							
						}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_GET_CATEGORIZATION2]({commit, state,getters,dispatch}, data){																
  		try {
			const inputJson = data ; let profile_data = '';
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout

			if(inputJson.responseDataFromUrl){
				profile_data = inputJson.responseDataFromUrl
				delete inputJson.responseDataFromUrl
			}else{
				delete inputJson.profile_data
			}
			
			
			parameter.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CATEGORIZATION, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				if ('info' in data){
						if (data.info === 'OK') {
							let cat_array , get_profile_data ;
							if(profile_data != '' && profile_data.length > 0){
								cat_array = [{"mcx" : profile_data[1] , "ncdex" : profile_data[2]}];
							}else{
								// MCX is currently the active categorization flow.
								// Keep it available by default and mark it done only when
								// a categorization record exists for exchange 1.
								cat_array = [{"mcx" : true , "ncdex" : false}];
								get_profile_data = getters[Const.GET_PROFILE_LIST]
								if(parseInt(get_profile_data.result[0].NCDEX) == 1){
									cat_array[0].ncdex = true
								}
							}
						

						if(data.data.length >0){
							let i ;
							for(i=0 ; i<= data.data.length-1 ; i++){
								if(parseInt(data.data[i].exchange) == 1){
									cat_array[0].mcx = false
									if(profile_data == '' && parseInt(get_profile_data.result[0].user.step) == 7){
										parameter.$router.replace('/required/document/verification')
									}else if(profile_data != ''){
										parameter.$router.replace('/Segments/segment')
									}
								}
								if(parseInt(data.data[i].exchange) == 2){
									cat_array[0].ncdex = false
									//console.log('nnnn=====',this.$route)
									if(profile_data == '' && parseInt(get_profile_data.result[0].user.step) == 7){
										parameter.$router.replace('/required/document/verification')
									}else if(profile_data != ''){
										parameter.$router.replace('/Segments/segment')
									}
								}
								if(data.data[i].exchange == "1,2"){
									cat_array[0].ncdex = false
									cat_array[0].mcx = false
									if(profile_data == '' && parseInt(get_profile_data.result[0].user.step) == 7){
										parameter.$router.replace('/required/document/verification')
									}else if(profile_data != ''){
										parameter.$router.replace('/Segments/segment')
									}
								}
								
							}
							if(i == data.data.length){
								if(cat_array[0].mcx == true){
									parameter.mcx_ncdex_flag = 'mcx'
								}else if(cat_array[0].ncdex == true){
									parameter.mcx_ncdex_flag = 'ncdex'
								}else{
									parameter.mcx_ncdex_flag = ''
								}

								if(profile_data == ''){
									commit(Const.SET_CATEGORIZATION_DATA,cat_array)
								}else{
									commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{})
									commit(Const.SET_CATEGORIZATION_DATA_THROUGH_TICKET,cat_array)
								}
								
								parameter.$parent.pageLoader = false
							}
						}else{
							if(profile_data == ''){
								commit(Const.SET_CATEGORIZATION_DATA,cat_array)
							}else{
								
								commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{})
								commit(Const.SET_CATEGORIZATION_DATA_THROUGH_TICKET,cat_array)
							}
							parameter.$parent.pageLoader = false
						}
						
					}
					else{	
						parameter.$parent.pageLoader = false
						parameter.pageLoader1 = true
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_MCX_NCDEX]({commit, state,getters,dispatch}, data){																
  		try {
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			
			parameter.$parent.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_MCX_NCDEX, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.$parent.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						commit(Const.SET_COMPLAINT_OTP_VIEW_DATA, data.data)
						const message_success = "We have sent an OTP to your mobile number  and to your email"
						parameter.flashSuccess(message_success, {timeout: msz_display_time});
						if(parameter.webEngageCallback) {
							webengage.track("Categorization", {"Value": "Yes"});
							console.log("Categorization")
						}
					}
					else{	
						parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_SUBMIT_CONSENT]({commit, state, getters, dispatch}, data){
		return new Promise((resolve, reject) => {
			try { 
			let tempURL = Enpoints.BASE_URL + Enpoints.EP_CLIENT_CONSENT
			Api.post(tempURL, {...data})
				.then((res) => {
					const { data } = res;
					console.log(data)
					resolve(data); // Resolve the Promise with the data.
				})
				.catch((ex) => {
					let error = 'Oops! Something went wrong';
					Vue.notify({
					group: 'foo',
					title: 'error!',
					text: error,
					type: 'error'
					});
					_handleErrorResponse(ex, commit);
					reject(false); // Reject the Promise with `false` as the error value.
				});
			} catch (ex) {
				console.log(ex)
				reject(ex); // Reject the Promise with the caught error.
			}
		})
	},
	[Const.RUN_ADD_DATA]({commit, state, getters, dispatch}, data){							
  		try { 
			var get_array = []
			get_add_data(data,get_array)

			let setExtension = ''
			if(get_array.module == 'others' || get_array.module == 'complaint' || get_array.module == 'unpledge' || get_array.module == 'Buyback'){
				setExtension = 'xlsFileAllowed'
			}
			get_array.root_file_address.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + (get_array.API_LINK) , get_array.inputJson , {'Authorization': 'Bearer ' + getters.GET_TOKEN,  'sendExt' : setExtension})
			.map(response => response.data)
			.subscribe(data => 
			{	get_array.root_file_address.pageLoader = false
				if('info' in data) {
					if(data.info === 'OK'){
						if(get_array.module == 'support_add'){ 
							dispatch(Const.RUN_GET_LISTING_DATA, {"status":0,"page":1,"page_name":'/Tickets/support',"rout": get_array.rout,"parameter" : get_array.parameter,"mutation_variable": "SET_SUPPORT_LIST"});
						}else if(get_array.module == 'support_reply'){
							if(get_array.flag == "cancel_ticket"){
								get_array.parameter.msz_Box = false
							}
							get_array.parameter.reset()
							dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, {"id":get_array.variable,"rout": get_array.rout,"parameter" : get_array.parameter});
						}else if(get_array.module == 'esign_adhar'){
							window.location.href = data.data.result.aadharESignServerURL;
						}else if(get_array.module == 'esign_adhar_KYC'){
							window.location.href = data.data.result.aadharESignServerURL;
							// if(validObjectWithParameterKeys(data, ['data']) 
							// && validObjectWithParameterKeys(data.data, ['identifier', 'entity_id', 'id'])
							// ){
							// 	const {
							// 		data: {
							// 			identifier,
							// 			entity_id, 
							// 			id
							// 		} = {}
							// 	  } = data;
							// 	digio.init();
							// 	digio.submit(entity_id, identifier, id);
							// }
						}else if(get_array.module == 'payin'){
							window.location.href = data.data.result;
						}else if((get_array.module == 'email' || get_array.module == 'mobile_no') && data.data.status != undefined && parseInt(data.data.status) == 0 ){
							commit(Const.SET_COMPLAINT_OTP_VIEW_DATA, data.data)
						}else{
							commit(Const.SET_COMPLAINT_OTP_VIEW_DATA, data.data)
							//user data
							const user_data = getters[types.GET_USER]
							const message_success = "We have sent an OTP to your mobile number "+user_data.mobile_no+" and to your email "+user_data.email
							get_array.parameter.flashSuccess(message_success, {timeout: msz_display_time});
						}
					}else{ 
						if(data.msg == "Request Cann't be created as account is closed"){
							dispatch(types.RUN_USER_LOGOUT, {'router': get_array.parameter.$router, 'parameter': get_array.parameter})
							get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
						}else if(get_array.module == 'support_reply'){
							if(get_array.flag == "cancel_ticket"){
								get_array.parameter.msz_Box = false
							}
							get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
						}else if(get_array.module == 'bank_details'){
							get_array.parameter.document = false
							get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
						}else{
							get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
			            }
					}
				}
			},
			e => { _handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_AGGREGATOR_DATA]({commit, state, getters, dispatch}, data){	
		const inputJson = data
		const rout = inputJson.rout
		const parameter = inputJson.parameter
		delete inputJson.parameter
		delete inputJson.rout
		return new Promise((resolve, reject) => {
			try { 
				RxFactory.post(Enpoints.BASE_URL+ Enpoints.EP_RUN_AGGREGATOR_TICKET_SUBMIT, inputJson.payload , {'Authorization': 'Bearer ' + getters.GET_TOKEN})
				.map(response => response.data)
				.subscribe(data => {
					if('info' in data) {
						resolve(true);
						commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
						dispatch(Const.RUN_GET_REASON_WISE_TICKET, {});
						if(data.data.idData){
							localStorage.setItem("responseDataFromUrl", data.data.idData);
						}
						var user = localStorage.getItem('user')
						user = atob(user)	;	user = JSON.parse(user)
						user.do_aggregator = 0										
						localStorage.setItem('user', btoa(JSON.stringify(user)))
						dispatch(types.RUN_STATE_LOAD, {});
					}
				},
				e => { 
					_handleErrorResponse(e, commit)	
					reject(false);
				}) 
			}
			catch(ex){	
				reject(false);
				_handleErrorResponse(ex, commit)
			}
		  });				

	},
//-----------------------confirm update Data-------------------------	
	[Const.RUN_CONFIRM_UPDATE_DATA]({commit, state,getters,dispatch}, data){																
  		try {
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			
			parameter.$parent.$parent.$parent.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CONFIRM_UPDATE_DATA, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.$parent.$parent.$parent.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						parameter.$parent.ticket_button = true
						commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
					}
					else{	
						get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	[Const.RUN_GET_REASON_WISE_TICKET]({ commit, state, getters, dispatch }, data) {
		return new Promise((resolve, reject) => {
			try {
				RxFactory.post(Enpoints.BASE_URL + Enpoints.GET_REASON_WISE_TICKET, data, {
					Authorization: 'Bearer ' + getters.GET_TOKEN,
				})
					.map(response => response.data)
					.subscribe(
						data => {
							if ('info' in data && data.info === 'OK') {
								commit(Const.SET_REASON_TICKET, data.data);
							}
							resolve(data); // resolve after processing
						},
						e => {
							_handleErrorResponse(e, commit);
							reject(e); // reject on error
						}
					);
			} catch (ex) {
				_handleErrorResponse(ex, commit);
				reject(ex); // reject on error
			}
		});
	},
	

  	
//-----------------------otp Add Data---------------------
	[Const.RUN_ADD_OTP_DATA]({commit, state, getters, dispatch}, data){								     
  		try {
			var get_array = []
			get_otp_add_data(data,get_array)
			get_array.root_file_address.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + (get_array.API_LINK) , get_array.inputJson , {'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	get_array.root_file_address.pageLoader = false 
				if('info' in data) {
					if (data.info === 'OK') {
						var jsons = getters[types.GET_USER]
						if(get_array.module == 'email' || get_array.module == 'mobile_no'){
							if(get_array.module == 'mobile_no'){
								jsons.mobile_no = data.data.mobile_no											
								commit(types.SET_STATE , jsons)
								var user = localStorage.getItem('user')
								user = atob(user)	;	user = JSON.parse(user)
								user.mobile_no = data.data.mobile_no											
								localStorage.setItem('user', btoa(JSON.stringify(user)))
							}else if(get_array.module == 'email'){
								jsons.email = data.data.new_email						
								commit(types.SET_STATE , jsons)
								var user = localStorage.getItem('user')
								user = atob(user)	;	user = JSON.parse(user)
								user.email = data.data.new_email							
								localStorage.setItem('user', btoa(JSON.stringify(user)))
							}
							commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
							//get_array.parameter.flashSuccess(data.msg, {timeout: msz_display_time})
						}else{
							let cat_data = getters[Const.GET_CATEGORIZATION_DATA]
							
							if(get_array.module == 'MCX'){
								if(get_array.inputJson.ticket_id != ''){
									localStorage.removeItem('responseDataFromUrl');
									//get_array.parameter.$parent.$parent.responseDataFromUrl = ''
								}

								console.log("Verification Otp Success")
								webengage.track("Verification Otp Success", {"Value": "Yes"});

								if(parseInt(jsons.step) == 7){
									get_array.parameter.$router.replace('/required/document/verification')
									commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{})
								}else{
									commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
								}
								
							}else if(get_array.module == 'trading_platform'){
								get_array.parameter.$parent.profileDAta()
								commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
							}else if(get_array.module == 'segment_sec' || get_array.module == 'enable_exchange'){
								if(data.data.idData){
									localStorage.setItem("responseDataFromUrl", data.data.idData);
								}
								
								commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
							}else if(get_array.module == 'add_nominee'){
								get_array.parameter.$parent.$parent.$parent.enableRequestElementOpenView('openRequest',data.data.ticketId)
							} else if(get_array.module == 'gross_annual_income') {
								console.log('gross-annual')
								commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"gross_annual_only" : "true"})
							}else if(get_array.module == 'asba-activation'){
								// get_array.parameter.$parent.setScreen(get_array.is_asba_activated);
								commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})
							} else{
								commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,{"status" : "success"})

							}
							//get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
						}
						dispatch(Const.RUN_GET_REASON_WISE_TICKET, {});
						
					}
					else{		
						if(get_array.module == 'MCX'){

							console.log("Verification Otp Failed")
							webengage.track("Verification Otp Failed", {"Value": "Yes"});
						}
						if((get_array.module == 'email' || get_array.module == 'mobile_no') && (data.msg.status == '0')){
							commit(Const.SET_COMPLAINT_OTP_VIEW_DATA,data.msg)
						}else{
							get_array.parameter.flashError(data.msg, {timeout: msz_display_time})
						}
						
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		} catch (ex) {	_handleErrorResponse(ex, commit)  }
  	},
//------------------------listing Data-----------------
	[Const.RUN_GET_LISTING_DATA]({commit, state, getters, dispatch}, data){					
  		try {
			var get_array = []
			get_listing_data(data,get_array)
			get_array.parameter.pageLoader1 =  true
			let user_json = getters[types.GET_USER]
			// if(parseInt(user_json.step) == 7 && !(localStorage.getItem("step_for_gtag"))){
			// 	window.fbq('track', 'PJ_step_13');
			// 	localStorage.setItem("step_for_gtag", user_json.step);
			// }
			RxFactory.post(Enpoints.BASE_URL + (get_array.API_LINK),get_array.inputJson, {'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	get_array.parameter.pageLoader1 = false 
				 if ('info' in data) {
					if (data.info === 'OK') {
						
						try{
							if(Object.keys(data.data.Holdings)[0] == "BranchCode"){
								data.data.Holdings = [data.data.Holdings]
							}
						}
						catch(e){
							// console.log("");
						}


						if(get_array.mutation_variable == 'SET_CONTRACT_NOTE_LIST'){
							let arr = [];
						  	for(let key in data.data){
						  		arr.push({key : key, value: data.data[key]})
						  	}
						  	arr.sort((a,b) => b.key-a.key);
							commit(Const[get_array.mutation_variable], arr)
						}else if(get_array.mutation_variable == 'SET_TAX_REPORT_LIST1'){
						  	if(data.data.LongTerm != undefined && data.data.LongTerm.length > 0){
						  		let longTermJson = {}, longTeromArray = [] ;
						  		for(let i = 0 ; i<=data.data.LongTerm.length-1 ; i++){
						  			if(!longTermJson.hasOwnProperty(data.data.LongTerm[i].ISINCode)){
						  				longTermJson[data.data.LongTerm[i].ISINCode] = {}
						  				longTermJson[data.data.LongTerm[i].ISINCode]['ScripName'] = data.data.LongTerm[i].ScripName
										longTermJson[data.data.LongTerm[i].ISINCode]['ISINCode'] = data.data.LongTerm[i].ISINCode
										longTermJson[data.data.LongTerm[i].ISINCode]['NetPL'] = data.data.LongTerm[i].NetPL
										longTermJson[data.data.LongTerm[i].ISINCode]['GFPL'] = data.data.LongTerm[i].GFPL
										longTermJson[data.data.LongTerm[i].ISINCode]['GFNETPL'] = data.data.LongTerm[i].GFNETPL
										longTermJson[data.data.LongTerm[i].ISINCode]['longArray'] = []
										longTermJson[data.data.LongTerm[i].ISINCode]['longArray'].push(data.data.LongTerm[i])
						  			}else{
						  				longTermJson[data.data.LongTerm[i].ISINCode]['ScripName'] = data.data.LongTerm[i].ScripName
										longTermJson[data.data.LongTerm[i].ISINCode]['ISINCode'] = data.data.LongTerm[i].ISINCode
										longTermJson[data.data.LongTerm[i].ISINCode]['NetPL'] += data.data.LongTerm[i].NetPL
										longTermJson[data.data.LongTerm[i].ISINCode]['GFPL'] += data.data.LongTerm[i].GFPL
										longTermJson[data.data.LongTerm[i].ISINCode]['GFNETPL'] += data.data.LongTerm[i].GFNETPL
										longTermJson[data.data.LongTerm[i].ISINCode]['longArray'].push(data.data.LongTerm[i])
						  			}
						  			
						  			if(i==data.data.LongTerm.length-1){
						  				let count = 0
						  				for(let key in longTermJson){
						  					count++
						  					longTeromArray.push(longTermJson[key])
						  					if(count == Object.keys(longTermJson).length){
							  					data.data['longTermJson'] = longTeromArray
							  				}
						  				}
						  			}
						  		}
						  	}else{
						  		data.data['longTermJson'] = []
						  	}

						  	if(data.data.ShortTerm != undefined && data.data.ShortTerm.length > 0){
						  		let ShortTermJson = {}, ShortTermArray = [] ;
						  		for(let i = 0 ; i<=data.data.ShortTerm.length-1 ; i++){
						  			if(!ShortTermJson.hasOwnProperty(data.data.ShortTerm[i].ISINCode)){
						  				ShortTermJson[data.data.ShortTerm[i].ISINCode] = {}
						  				ShortTermJson[data.data.ShortTerm[i].ISINCode]['ScripName'] = data.data.ShortTerm[i].ScripName
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['ISINCode'] = data.data.ShortTerm[i].ISINCode
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['NetPL'] = data.data.ShortTerm[i].NetPL
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['shortArray'] = []
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['shortArray'].push(data.data.ShortTerm[i])
						  			}else{
						  				ShortTermJson[data.data.ShortTerm[i].ISINCode]['ScripName'] = data.data.ShortTerm[i].ScripName
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['ISINCode'] = data.data.ShortTerm[i].ISINCode
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['NetPL'] += data.data.ShortTerm[i].NetPL
										ShortTermJson[data.data.ShortTerm[i].ISINCode]['shortArray'].push(data.data.ShortTerm[i])
						  			}
						  			
						  			if(i==data.data.ShortTerm.length-1){
						  				let count = 0
						  				for(let key in ShortTermJson){
						  					count++
						  					ShortTermArray.push(ShortTermJson[key])
						  					if(count == Object.keys(ShortTermJson).length){
							  					data.data['ShortTermJson'] = ShortTermArray
							  				}
						  				}
						  			}
						  		}
						  	}else{
						  		data.data['ShortTermJson'] = []
						  	}

						  	if(data.data.Jobbing != undefined && data.data.Jobbing.length > 0){
						  		let JobbingJson = {}, JobbingArray = [] ;
						  		for(let i = 0 ; i<=data.data.Jobbing.length-1 ; i++){
						  			if(!JobbingJson.hasOwnProperty(data.data.Jobbing[i].ISINCode)){
						  				JobbingJson[data.data.Jobbing[i].ISINCode] = {}
						  				JobbingJson[data.data.Jobbing[i].ISINCode]['ScripName'] = data.data.Jobbing[i].ScripName
										JobbingJson[data.data.Jobbing[i].ISINCode]['ISINCode'] = data.data.Jobbing[i].ISINCode
										JobbingJson[data.data.Jobbing[i].ISINCode]['NetPL'] = data.data.Jobbing[i].NetPL
										JobbingJson[data.data.Jobbing[i].ISINCode]['JobbingArray'] = []
										JobbingJson[data.data.Jobbing[i].ISINCode]['JobbingArray'].push(data.data.Jobbing[i])
						  			}else{
						  				JobbingJson[data.data.Jobbing[i].ISINCode]['ScripName'] = data.data.Jobbing[i].ScripName
										JobbingJson[data.data.Jobbing[i].ISINCode]['ISINCode'] = data.data.Jobbing[i].ISINCode
										JobbingJson[data.data.Jobbing[i].ISINCode]['NetPL'] += data.data.Jobbing[i].NetPL
										JobbingJson[data.data.Jobbing[i].ISINCode]['JobbingArray'].push(data.data.Jobbing[i])
						  			}
						  			
						  			if(i==data.data.Jobbing.length-1){
						  				let count = 0
						  				for(let key in JobbingJson){
						  					count++
						  					JobbingArray.push(JobbingJson[key])
						  					if(count == Object.keys(JobbingJson).length){
							  					data.data['JobbingJson'] = JobbingArray
							  				}
						  				}
						  			}
						  		}
						  	}else{
						  		data.data['JobbingJson'] = []
						  	}

						  	commit(Const[get_array.mutation_variable], data.data)
							
						}else if(get_array.mutation_variable == 'SET_FINANCIAL_LEDGER_LIST1'){
							if(data.data.length > 0){
								commit(Const[get_array.mutation_variable], data.data)
								get_array.parameter.fetchData(1)
    							let array = [], json = {};
    							for(let i =0 ; i<=data.data.length-1 ; i++){
    								json = {
    									'exchange' : data.data[i].exchange,
    									'Date' : '',
    									'narration' : data.data[i].narration,
    									'bill_no' : data.data[i].bill_no,
    									'trade_Date' :  moment(data.data[i].trade_Date).format('DD/MM/YYYY'),
    									'debit' : data.data[i].debit,
    									'credit' : data.data[i].credit,
    									'running_balance' : data.data[i].running_balance
    								}
    								array.push(json)
    								if(i == data.data.length-1){
    									get_array.parameter.json_data = array
    								}
    							}
							}else{
								commit(Const[get_array.mutation_variable], data.data)
							}
						}else{
							commit(Const[get_array.mutation_variable], data.data)
						}



						if(get_array.mutation_variable == "SET_POSITION_HOLDING_ORDER_LIST"){
							localStorage.setItem("margin_info", JSON.stringify(data.data.MARGIN_INFO.MARGIN_INFO));
							commit(Const.SET_MARGIN_LIST, data.data.MARGIN_INFO.MARGIN_INFO)
						}else if(get_array.mutation_variable == "SET_PROFILE_LIST"){
								//backup
								let user_json = getters[types.GET_USER]
								user_json.profile.passport_image = data.data.result[0].passport_image
								commit(types.SET_STATE, user_json)
	
								let user_data = JSON.parse(window.atob(localStorage.getItem("user")));
								user_data.profile.passport_image = data.data.result[0].passport_image
								localStorage.setItem('user', btoa(JSON.stringify(user_data)))

								//added by manvir 
							// const user_json = getters[types.GET_USER];
							// const user_data = JSON.parse(
							//   window.atob(localStorage.getItem("user"))
							// );
							
							// if(validObjectWithParameterKeys(data.data, ['result']) 
							// && strictValidArrayWithMinLength(data.data.result)
							// && validObjectWithParameterKeys(data.data.result[0], ['passport_image'])
							// && validObjectWithParameterKeys(user_json, ['profile']) 
							// && validObjectWithParameterKeys(user_data, ['profile']) 
							// ){
							// 	const img = data.data.result[0].passport_image;
							// 	user_json.profile.passport_image = img;
							// 	commit(types.SET_STATE, user_json);
			  
							// 	user_data.profile.passport_image = img;
							// 	localStorage.setItem("user", btoa(JSON.stringify(user_data)));
			  
							// }
							
							if(get_array.pageProfileName){
								get_array.parameter.categorizeFunc()
							}
						}
					}
					else{	   }
				}  
			},
			e => {_handleErrorResponse(e, commit)}
		  )
		}catch(ex){_handleErrorResponse(ex, commit)}
  	},
//-------------------------resend Otp--------------------
	[Const.RUN_RESEND_OTP_DATA]({commit, state,getters}, data){																
  		try {
  			let API_LINK;
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			let  Module = '';
			if(inputJson.Module != undefined ){
				Module = inputJson.Module
				delete inputJson.Module
			}
			
			if(Module == 'MCX' || Module == 'NCDEX'){
				API_LINK = Enpoints.EP_MCX_NCDEX
			}else{
				API_LINK = Enpoints.EP_RESEND_OTP_DATA
			}
			parameter.otp_pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + API_LINK, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.otp_pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						if(Module == 'MCX') {
							webengage.track("Verification Otp Resend Success", {"Value": "Yes"});
							console.log("Verification Otp Resend Success")
						} 
						parameter.$parent.flashSuccess(data.msg, {timeout: msz_display_time})
					}
					else{	
						if(Module == 'MCX') {
							webengage.track("Verification Otp Resend Failed", {"Value": "Yes"});
							console.log("Verification Otp Resend Failed")
						} 
						parameter.$parent.flashError(data.msg, {timeout: msz_display_time})
		            }
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
//------------------------------------view Support Data----------------------------
	[Const.RUN_VIEW_SUPPORT_DETAIL]({commit, state,getters}, data){																
  		try {
  			commit(Const.SET_SUPPORT_VIEW, {})
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout

			const module = inputJson.module				// for services
			delete inputJson.module
			parameter.pageLoader_view_support_detail =  true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_VIEW_SUPPORT_DETAIL, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.pageLoader_view_support_detail =  false	
				if ('info' in data){
					if (data.info === 'OK') {
						localStorage.setItem("Support", JSON.stringify(data.data));
						commit(Const.SET_SUPPORT_VIEW, data.data)
						if(module){
							rout.replace({ name: "services.ServicesIndex",params:{tabName:"openRequest"},query:{id:inputJson.id }}) 
					    }
					}
					else{	
						/*parameter.$notify({
							group: 'foo',
							text: data.msg,
							type: 'error',
							closeOnClick : true
		                });*/
		            }
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
//------------------------------------------------------dropdown Reason List------------
	[Const.RUN_GET_SUPPORT_REASON_LIST]({commit, state, getters, dispatch}, data){						
  		try {
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_SUPPORT_REASON_LISTING,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{   
				if('info' in data){
					if (data.info === 'OK') {
						commit(Const.SET_SUPPORT_REASON_LIST, data.data)
					}else{}
				}
			},
			e => { _handleErrorResponse(e, commit)})
		} catch(ex){ _handleErrorResponse(ex, commit) }
  	},
//------------------------------------------------------platform List------------------------	
	[Const.RUN_GET_PLATFORM_LIST]({commit, state, getters, dispatch}, data){						
  		try {
  			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_PLATFORM_LIST,data, {'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{   parameter.platform_loader =  false
				if('info' in data){
					if (data.info === 'OK') {
						commit(Const.SET_PLATFORM_LIST, data.data)
					}else{}
				}
			},
			e => { _handleErrorResponse(e, commit)})
		} catch(ex){ _handleErrorResponse(ex, commit) }
  	},
//------------------------------------------------------get Current Leverage---------
  	[Const.RUN_GET_CURRENT_LEVERAGE]({commit, state, getters, dispatch}, data){						
  		try {
  			const inputJson = data
			const parameter = inputJson.parameter
			delete inputJson.parameter
			const page = inputJson.page
			delete inputJson.page
			const fun_back_clear_var = inputJson.fun_back_clear_var
			delete inputJson.fun_back_clear_var
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CURRENT_LEVERAGE,data, {'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{   if('info' in data){
					if (data.info === 'OK') {
						if(!page){
							if(data.data.length > 0){
								parameter.leverage_variable = data.data[0].plan_id
								if(data.data[0].plan_id == 2){
									parameter.info_leverage = ''
									parameter.value="BASIC"
								}else{
									parameter.info_leverage = true
								}
							}else{
								parameter.info_leverage = ''
								parameter.leverage_variable = 2
								parameter.value="BASIC"
							}
						}
						if(fun_back_clear_var){
							commit(Const.SET_COMPLAINT_OTP_VIEW_DATA, [])
						}
						
						commit(Const.SET_CURRENT_LEVERAGE, data.data)
					}else{}
				}
			},
			e => { _handleErrorResponse(e, commit)})
		} catch(ex){ _handleErrorResponse(ex, commit) }
  	},
	[Const.RUN_ADD_PROFILE_IMAGE_DATA]({commit, state, getters, dispatch}, data){		
		try {
  			let form_data  = ""
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			//--------------document validation---------------------
			//const doc_array = inputJson.doc_array
			//delete inputJson.doc_array
			//const kra = inputJson.kra
			//delete inputJson.kra
			//const cms = inputJson.cms
			//delete inputJson.cms

			// console.log("data", data)
			const profile_data = inputJson.profile_data
			delete inputJson.profile_data
			//------------------------------------------------------
			//const page_name_profile_image = inputJson.page_name_profile_image
			//delete inputJson.page_name_profile_image

			/*if(inputJson.form){
				const form = inputJson.form
				form_data = form
				delete inputJson.form
			}*/
			parameter.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADD_PROFILE_IMAGE_DATA, data.form ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.$parent.pageLoader = false
				if ('info' in data){
					if(window.location.pathname === '/ipv-redirect' && inputJson.redirect_url){
						window.location.href = inputJson.redirect_url || '/undefined'
					}
					if (data.info === 'OK') {
						//if(page_name_profile_image){
							//if(form_data != ''){
							//	dispatch(types.RUN_ADD_REGISTER_DATA_STEP4, {"profile_data":profile_data,"cms":cms,"kra" : kra,"form":form_data,"doc_array" : //doc_array,"rout":rout,"parameter": parameter});
							//}else{
								// if(parameter.mobileScreen == false){
								// 	parameter.mobileScreenMsz = '0'
								// 	let user_json = getters[types.GET_USER]
								// 	user_json.step = 4
								// 	commit(types.SET_STATE, user_json)
								// 	var user = localStorage.getItem('user')
								// 	user = atob(user)	;	user = JSON.parse(user)
								// 	user.step = 4										
								// 	localStorage.setItem('user', btoa(JSON.stringify(user)))
								// 	dispatch(types.RUN_STATE_LOAD, {});
								// 	rout.replace('/Users/register/step5');
								// }else{
								// 	parameter.mobileScreenMsz = '1'
								// }
								//parameter.mobileScreenMsz = '0'
								let user_json = getters[types.GET_USER]
								user_json.step = 4
								commit(types.SET_STATE, user_json)
								var user = localStorage.getItem('user')
								user = atob(user)	;	user = JSON.parse(user)
								user.step = 4										
								localStorage.setItem('user', btoa(JSON.stringify(user)))
								dispatch(types.RUN_STATE_LOAD, {});
								rout.replace('/Users/register/step5');
								
								let base_message = "Hi "+getters[types.GET_USER].username + '<br>'
								let i = 0 ; 
								
								if(!(inputJson.documentJsonData.hasOwnProperty('bank'))){
									if(!(inputJson.documentJsonData.hasOwnProperty('bank'))){
										

										let bank_detail = "Documents accepted as income proof are:<br> A) 6 months bank statement <br> B) 3 months salary slips <br>  C) Latest ITR (Income Tax Return)  <br>  D) DEMAT holding statement <br> E) Net worth certificate <br>  F) Copy of form 16" ;
										base_message = base_message +" Please upload your Income Proof" + '<br>'+ bank_detail + ' <br><br>'
									}
									dispatch(types.RUN_STEP_SKIP_API, {"reason" : 17,"comment" : base_message,"rout":rout,"parameter": parameter});
								}
							//}
						/*else{
							dispatch(Const.RUN_GET_LISTING_DATA, {"mutation_variable": "SET_PROFILE_LIST","rout":rout,"parameter": parameter});
							parameter.isHidden	= false
							parameter.upload_img = false
							parameter.flashSuccess(data.msg, {timeout: msz_display_time});

						}*/
						
					}else{
						/*if(page_name_profile_image){
							parameter.flashError(data.msg, {timeout: msz_display_time})
						}else{parameter.isHidden = false ;parameter.upload_img = false; parameter.flashError(data.msg, {timeout: msz_display_time})}*/
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
  	[Const.RUN_ADD_PROFILE_IMAGE_DATA_FROM_PROFILE]({commit, state, getters, dispatch}, data){														
		try {
  			
			
			let form_data  = ""
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			//------------------------------------------------------
			//const page_name_profile_image = inputJson.page_name_profile_image
			//delete inputJson.page_name_profile_image
			let resp = {}
			resp.profile_image = data.profile_image
			/*if(inputJson.form){
				const form = inputJson.form
				form_data = form
				delete inputJson.form
			}*/



			parameter.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADD_PROFILE_IMAGE_DATA+"/UP", resp, {'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	
				parameter.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						
						dispatch(Const.RUN_GET_LISTING_DATA, {"mutation_variable": "SET_PROFILE_LIST","rout":rout,"parameter": parameter});
						parameter.isHidden	= false
						parameter.upload_img = false
						parameter.flashSuccess(data.msg, {timeout: msz_display_time});

						
					}else{
						/*if(page_name_profile_image){
							parameter.flashError(data.msg, {timeout: msz_display_time})
						}else{parameter.isHidden = false ;parameter.upload_img = false; parameter.flashError(data.msg, {timeout: msz_display_time})}*/
					}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},

  	
  	[Const.RUN_GET_PCR_LEDGER_DATA]({commit, state, getters, dispatch}, data){														
		try {
			const inputJson = data
			const rout = inputJson.rout
			const parameter = inputJson.parameter
			delete inputJson.parameter
			delete inputJson.rout
			parameter.$parent.$parent.pageLoader = true
			RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_PCR_LEDGER_DATA, data ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
			.map(response => response.data)
			.subscribe(data => 
			{	parameter.$parent.$parent.pageLoader = false
				if ('info' in data){
					if (data.info === 'OK') {
						commit(Const.SET_PCR_DATA, data.data)
					}else{	}
				}
			},
			e => {	_handleErrorResponse(e, commit)	}) 
		}catch(ex){	_handleErrorResponse(ex, commit) }
  	},
}
//---------------------------Functions-----------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
 	commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
  	let response = {info: 'NOK', msg: 'Service not available'}
  	if (typeof e.response === 'undefined') {
    	try {
      		const statusCheck = e.toString().toLowerCase()
	      	if (statusCheck.indexOf('network') > -1) {
	        	response = {info: 'NOK', msg: 'Network Error'}
	      	}
    	} catch (e) {}
  	} else {
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}
function _handleLogout (data, commit, options) {
	let user = {}
	const state = []
	//window.sessionStorage.setItem('user_info', "")
	//window.sessionStorage.setItem('user', "")
	localStorage.clear();
	sessionStorage.clear();
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace("/")
	}
}
function  get_listing_data(get_json_data,get_array) {
	var API_LINK ;var pageName ; var root_file_address;   var pageProfileName = '';                    
	const inputJson = get_json_data
	const parameter = inputJson.parameter
	const rout = inputJson.rout
	const mutation_variable = inputJson.mutation_variable
	delete inputJson.parameter
	delete inputJson.rout
	delete inputJson.mutation_variable   
	if(inputJson.pageProfileName){
		pageProfileName = inputJson.pageProfileName
		delete inputJson.pageProfileName
	}
	
	root_file_address = parameter.$parent                        
  	if(mutation_variable == "SET_PROFILE_LIST"){
  		root_file_address = parameter
		API_LINK = Enpoints.EP_GET_PROFILE_LISTING
	}else if(mutation_variable == "SET_FINANCIAL_LEDGER_LIST"){
		API_LINK = Enpoints.EP_GET_FINANCIAL_LEDGER_LISTING
	}else if(mutation_variable == "SET_POSITION_HOLDING_ORDER_LIST"){
		let is_nest_user = '';
		is_nest_user = inputJson.is_nest_user                			           
		delete inputJson.is_nest_user
		if(is_nest_user != '' && is_nest_user == 'nest_user'){
			API_LINK = Enpoints.EP_NEST_USER_DATA
		}else{
			API_LINK = Enpoints.EP_GET_POSITION_HOLDING_ORDER_LISTINGs
		}
	}else if(mutation_variable == "SET_POSITION_KSOFT_HOLDING_ORDER_LIST"){
		API_LINK = Enpoints.EP_POSITION_KSOFT_HOLDING_ORDER_LIST
	}else if(mutation_variable == "SET_CLOSE_POSITION_LIST"){
		API_LINK = Enpoints.EP_GET_CLOSE_POSITION_LISTING
	}else if(mutation_variable == "SET_TRADE_CONFIRMATION_LIST"){
		API_LINK = Enpoints.EP_GET_TRADE_CONFIRMATION_LISTING
	}else if(mutation_variable == "SET_TAX_REPORT_LIST"){
		API_LINK = Enpoints.EP_GET_TAX_REPORT_LISTING
	}else if(mutation_variable == "SET_TAX_REPORT_LIST1"){
		API_LINK = Enpoints.EP_SET_TAX_REPORT_LIST1
	}else if(mutation_variable == "SET_KSOFT_TAX_REPORT_LIST"){
		API_LINK = Enpoints.EP_GET_KSOFT_TAX_REPORT_LISTING
	}else if(mutation_variable == "SET_FINANCIAL_LEDGER_LIST1"){
		API_LINK = Enpoints.EP_SET_FINANCIAL_LEDGER_LIST1
	}else if(mutation_variable == "SET_CONTRACT_NOTE_LIST"){
		API_LINK = Enpoints.EP_GET_CONTRACT_NOTE_LISTING
	}else if(mutation_variable == "SET_DEPOSIT_LIST"){
		API_LINK = Enpoints.EP_GET_DEPOSIT_LISTING
	}else if(mutation_variable == "SET_SUPPORT_LIST"){
		root_file_address = parameter.$parent.$parent
		pageName = inputJson.page_name                			           
		delete inputJson.page_name
		API_LINK = Enpoints.EP_GET_SUPPORT_LISTING
	}
	get_array.inputJson = inputJson
	get_array.rout = rout
	get_array.parameter = parameter
	get_array.API_LINK = API_LINK
	get_array.mutation_variable = mutation_variable
	get_array.pageName = pageName 									// only for support listing
	get_array.root_file_address = root_file_address	
	if(pageProfileName != ''){
		get_array.pageProfileName = pageProfileName
	}
	
	return get_array;
} 
function  get_add_data(get_json_data,get_array){
	console.log(get_json_data,get_array)
	var API_LINK; var variable; var root_file_address;	var inputJson = get_json_data ;var flag
	const parameter = inputJson.parameter ; const rout = inputJson.rout ; 
	const module = inputJson.request_type
	delete inputJson.parameter			  ; delete inputJson.rout    


	if(module == 'financial_statement' || module == 'bank_details' || module == 'reactivateNseBse' || module == 'segment_sec' || module == 'reactivateMcx' || module == 'address_change' || module == 'enable_exchange' || module == 'demat_account' || module == 'complaint' || module == 'others' || module == 'unpledge' || module == 'Buyback' || module == 'asba-activation'|| module == 'gross_annual_income'){
		
		if(module == 'asba-activation'){
			inputJson = inputJson
		} else {
			inputJson = inputJson.form
		}
		API_LINK = Enpoints.EP_ADD_COMPLAINT_DATA
		if(module == 'enable_exchange' || module == 'demat_account'){
			root_file_address = parameter.$parent.$parent.$parent
		}else{root_file_address = parameter.$parent.$parent.$parent}
	}else if(module == 'support_add'){
		inputJson = inputJson.form
		API_LINK = Enpoints.EP_ADD_SUPPORT_DATA
		root_file_address = parameter.$parent
	}else if(module == 'support_reply'){
		flag = inputJson.flag									   
		delete inputJson.flag
		variable = inputJson.id									   
		delete inputJson.id
		inputJson = inputJson.form
		API_LINK = Enpoints.EP_REPLY_SUPPORT_DATA
		root_file_address = parameter.$parent.$parent.$parent
	}else if( module == 'update_leverage' || module == ''  ||  module == 'api-compalints' || module == 'account_close' ||  module == 'add_nominee' || module == 'email' || module == 'mobile_no' || module == 'pay' || module == 'trading_platform'){
		/*module == 'complaint' || module == 'others'*/
		API_LINK = Enpoints.EP_ADD_COMPLAINT_DATA
		if(module == 'update_leverage'){
			root_file_address = parameter.$parent
		}else if(module == 'add_nominee' || module == 'account_close'){
			root_file_address = parameter.$parent.$parent.$parent
			//console.log("--add_nominee---",inputJson)
			if(module == 'add_nominee' && "nominee" in inputJson && inputJson.nominee == 0){
				inputJson = inputJson
			}else{
				inputJson = inputJson.form
			}
		}else{
			root_file_address = parameter.$parent.$parent.$parent
		}
	}else if(module == 'poa_requests' || module == 'bracketorder_requests'){
		API_LINK = Enpoints.EP_ADD_COMPLAINT_DATA
		root_file_address = parameter.$parent.$parent.$parent
	}else if(module == 'esign_adhar'){
		API_LINK = Enpoints.EP_ADD_ESIGN_ADHAR_DATA
		root_file_address = parameter.$parent.$parent.$parent.$parent
	}else if(module == 'esign_adhar_KYC'){
		
		API_LINK = Enpoints.EP_ADD_ESIGN_KYC_ADHAR_DATA
		root_file_address = parameter.$parent
	}
	else if(module == 'payin'){
		API_LINK = Enpoints.EP_ADD_PAYIN_DATA
		root_file_address = parameter.$parent
	}
	get_array.inputJson = inputJson
	get_array.rout = rout
	get_array.parameter = parameter
	get_array.API_LINK = API_LINK
	get_array.module = module
	get_array.variable = variable 									  // only for support reply
	get_array.root_file_address = root_file_address 
	get_array.flag = flag
	
	return get_array;
}
function  get_otp_add_data(get_json_data,get_array){
	var API_LINK; var root_file_address; var inputJson = get_json_data
	const rout = inputJson.rout ;   const parameter = inputJson.parameter ;    const module = inputJson.module
	delete inputJson.rout       ;   delete inputJson.parameter            ;    delete inputJson.module
	root_file_address = parameter.$parent.$parent.$parent.$parent
	API_LINK = Enpoints.EP_ADD_SERVICE_REQUEST_CHANGE_DATA
	if(module == 'demat_account' || module == 'poa_requests' || module == 'bracketorder_requests'){
		root_file_address = parameter.$parent.$parent
	}
	if(module == 'changeLeverage'){
		root_file_address = parameter.$parent.$parent
		API_LINK = Enpoints.EP_ADD_SERVICE_REQUEST_LEVERAGE
	}
	if(module == 'MCX' || module == 'NCDEX'){
		root_file_address = parameter.$parent.$parent.$parent
		API_LINK = Enpoints.EP_MCX_NCDEX_OTP
	}
	get_array.inputJson = inputJson
	get_array.rout = rout
	get_array.parameter = parameter
	get_array.API_LINK = API_LINK
	get_array.module = module
	get_array.root_file_address = root_file_address 	
	return get_array;
}



// WEBPACK FOOTER //
// ./src/plugins/prism/provider/candle-history/store-addons/actions.js